import { Box } from '@mui/material'
import { ComparisonTableType } from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.types'
import { ComparisonTable } from 'Features/Projects/Scenarios/Templates/TemplateResults/Comparison/Comparison.table'

type ComparisonViewProps = {
  data: ComparisonTableType[]
  isLoading: boolean
}

/** The template against the current plan, SKU group by SKU group. */
export const ComparisonView = ({ data, isLoading }: ComparisonViewProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
    <ComparisonTable data={data} isLoading={isLoading} />
  </Box>
)
